<template lang="html">
  <div>
    <div class="hor-padding pt-2 mt-1">
      <div class="mt-2">
        <div class="mail-field px-3" :class="{ 'mail-field-open pt-4': mail_open }">
          <input v-model="email" type="text" class="form-input" placeholder="email" autocomplete />
          <div class="font-red mb-3">{{ email_error }}</div>
          <input
            v-model="password"
            type="password"
            class="form-input"
            placeholder="password"
            autocomplete
            password
          />
          <div class="font-red">{{ password_error }}</div>
          <div class="text-right mt-2 pt-1 mb-3">
            <router-link :to="{ name: 'login.password.send' }" class="reset-password-link"
              >Forgot Password?</router-link
            >
          </div>
        </div>

        <v-btn
          color="#b21977"
          rounded
          depressed
          class="auth-btn ma-0"
          :class="{
            'mail-open': mail_open,
            'mail-inactive': mail_open && !mailBtnActive,
          }"
          @click="mail_open ? (mailBtnActive ? mailLogin() : '') : (mail_open = true)"
        >
          <i class="mail-icon fo-email-wh"></i>
          <span class="font-white font-bold sp-xs-space fa-1_1x">Log in with Email</span>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="submitting" persistent>
      <v-card>
        <div class="py-4 px-3">
          <div class="">Loading...</div>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      mail_open: false,
      email: '',
      email_error: '',
      password: '',
      password_error: '',
      submitting: false,
    };
  },

  computed: {
    mailBtnActive() {
      return this.email && this.password;
    },
  },

  methods: {
    ...mapMutations(['setToken', 'setHouse']),

    ...mapActions(['setMeItems']),

    mailLogin() {
      this.submitting = true;
      this.email_error = '';
      this.password_error = '';

      if (this.email && this.password) {
        axios
          .post('/oauth/token', {
            grant_type: 'password',
            client_id: process.env.VUE_APP_API_CLIENT_ID,
            client_secret: process.env.VUE_APP_API_SECRET,
            username: this.email,
            password: this.password,
            scope: '*',
          })
          .then((res) => {
            let token = res.data.access_token;
            axios
              .get('/user', {
                headers: {
                  Accept: 'application/json',
                  Authorization: 'Bearer ' + token,
                },
                params: {
                  with_admin: true,
                },
              })
              .then((res) => {
                let msg = res.data.msg;
                if (msg) {
                  if (msg == 'unconfirmed') {
                    alert('Please check out the comfirmation email.');
                  }
                }
                this.$emit('setInfo', {
                  accessToken: token,
                  user: res.data.user,
                });
              })
              .catch((e) => {
                alert('Log in failed. Please reload your browser and try again.');
                this.submitting = false;
                console.log(e);
              })
              .finally(() => {
                this.submitting = false;
              });
          })
          .catch((e) => {
            if (e.response && e.response.status == 401) {
              this.email_error = 'Email or Password incorrect.';
            }
            this.submitting = false;
          });
      } else {
        this.email_error = this.email ? '' : 'Please fill in your email address.';
        this.password_error = this.password ? '' : 'Please fill in the password.';
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.auth-btn {
  height: 60px;
  width: 100%;
  text-transform: inherit;
}
.auth-btn.mail-open {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
.auth-btn.mail-inactive {
  background-color: #fff !important;
  border: solid #b21977 2px;
}
.auth-btn.mail-inactive .font-white {
  color: #b21977;
}
.auth-btn.mail-inactive .fo-email-wh {
  content: url('/img/svgs/email-pi.svg');
}
.auth-btn.register {
  border: solid #2f0338 2px !important;
}
.mail-icon {
  height: 24px;
  margin-right: 18px;
}
.mail-field {
  transition: all 0.2s;
  height: 0;
  overflow: hidden;
}
.mail-field-open {
  height: auto;
  min-height: 120px;
  background-color: #fff;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  border: solid 1px #e6e0e7;
  border-bottom: none;
}
.form-input {
  width: 100%;
  border: solid 1px #e6e0e7;
  border-radius: 5px;
  height: 35px;
  padding: 0 16px;
  font-size: 16px;
  color: #2f0338;
  font-weight: bold;
  outline: none;
}
.form-input::placeholder {
  color: #e6e0e7;
}
.reset-password-link {
  color: #2f0338;
  border-bottom: solid 1px #2f0338;
}
</style>
